import { Toast } from 'bootstrap/dist/js/bootstrap.esm.min.js';

async function postData(url = "", data = {}) {
    // Default options are marked with *
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
}


(function () {
    "use strict";
    var toastElList = [].slice.call(document.querySelectorAll('.toast'))
    var toastList = toastElList.map(function (toastEl) {
        return new Toast(toastEl, {container: "body"})
    })

    function findAncestor(element, aclass) {
        while (element != null) {
            if (element.classList.contains(aclass)) {
                return element;
            }
            element = element.parentElement
        }
        return null;
    }

    var getParentAnchor = function (element) {
        while (element !== null) {
            if (element.tagName && element.tagName.toUpperCase() === "A") {
                return element;
            }
            element = element.parentNode;
        }
        return null;
    };

    document.querySelector("body").addEventListener('click', function (e) {
        localStorage.removeItem("caller");
        var anchor = getParentAnchor(e.target);
        if (anchor !== null) {
            localStorage.setItem("root", ROOT);
            let section = findAncestor(anchor, "section-bg");
            if (section != null) {
                let section_id = section.getAttribute('id');
                if (section_id != null) {
                    localStorage.setItem("caller", section_id);
                }
            }
            localStorage.setItem("origin", anchor.origin);
        }
    }, false);

    document.getElementById("contactform").addEventListener('submit', async function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (!event.target.checkValidity()) {
            return;
        }

        const nameVal = document.getElementById("name").value;
        const emailVal = document.getElementById("email").value;
        const subjectVal = document.getElementById("subject").value;
        const messageVal = document.getElementById("message").value;
        try {
            const data = await postData("/api/ContactEmailApi/submit", { id: HOME_ID, name: nameVal, email: emailVal, subject: subjectVal, message: messageVal });
            console.log(data)
            const contactForm = document.getElementById("contactform");
            contactForm.classList.remove("was-validated");
            contactForm.classList.remove("needs-validation");
            contactForm.reset();
            const successToast = document.getElementById("form-post-success");
            Toast.getInstance(successToast).show();
        } catch (error) {
            console.error(error);
            const errorToast = document.getElementById("form-post-error");
            Toast.getInstance(errorToast).show();
        }
    });
})()